import type { AvailableWidgetPreview, BackendReportWidget } from 'report/types';

export const isReportBackendWidget = (widget: BackendReportWidget | AvailableWidgetPreview): widget is BackendReportWidget => {
  return 'dashboard_widget_id' in widget && !('id' in widget);
};

export const isAvailableWidgetPreview = (widget: BackendReportWidget | AvailableWidgetPreview): widget is AvailableWidgetPreview => {
  return 'id' in widget && !('dashboard_widget_id' in widget);
};
